import { render, staticRenderFns } from "./IKUpload.vue?vue&type=template&id=cefbf3fe&"
import script from "./IKUpload.vue?vue&type=script&lang=js&"
export * from "./IKUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports